import { EmptyProps } from "@/Common/Components/BaseReactComponent";

class EmptyContent extends React.Component<EmptyProps, never> {
    public render(): JSX.Element {
        return (
            <div className="workspace">
                <div className="myle-page-header">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 hidden-sm-down" />
                        <div className="col-lg-6 col-md-6 col-sm-6">
                            <div className="clearfix" style={{ marginTop: "20px" }}>
                                <div className="pull-right" />
                                <div className="pull-right" />
                            </div>
                        </div>
                    </div>
                </div>
                <div id="posref" className="tb ws-scrollable">
                    <div className="clearfix" />
                </div>
                <div className="ws-footer table-pager-footer">
                    <div className="row">
                        <div className="col-lg-10 col-md-9 col-sm-8" />
                        <div className="col-lg-2 col-md-3 col-sm-4 text-right" />
                    </div>
                </div>
            </div>
        );
    }
}

export { EmptyContent };
